import DataGridNoRowsCustomOverlay from '@/components/datagrid/DataGridNoRowsOverlay';
import StyledDataGrid from '@/components/datagrid/StyledDataGrid';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Chip } from '@mui/material';
import { useEffect, useState } from 'react';
import UnitDataGridToolbar from './UnitDataGridToolbar';
import UnitDetailDrawer from './UnitDetailDrawer';

const UnitDataGrid = (props) => {
  const { units, isLoading } = props;
  const [rows, setRows] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    const initialRowsData = units?.map((unit) => ({
      id: unit?.UnitId,
      Account: unit?.Account,
      UnitId: unit?.UnitId,
      Name: unit?.Name,
      Description: unit?.Description,
      Sensors: unit?.UnitSensors,
      Tags: unit?.Tags,
      RecordedDataTypes: unit?.RecordedDataTypes,
      UnitSensors: unit?.UnitSensors,
      UnitType: unit?.UnitType,
      AlarmGroups: unit?.AlarmGroups,
    }));
    setRows(initialRowsData);
  }, [units]);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows?.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handleRowClick = (params) => {
    if (selectedRow && selectedRow.id === params.row.id) {
      setSelectedRow(null);
      setDrawerOpen(!drawerOpen);
    } else {
      setSelectedRow(params.row);
      setDrawerOpen(true);
    }
  };

  const getRowClassName = (params) => {
    return selectedRow && selectedRow.id === params.id ? 'selected-row' : '';
  };

  const columns = [
    // {
    //   field: 'UnitId',
    //   headerName: 'Unit ID',
    //   width: 150,
    //   renderCell: (params) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(params.value.toString());
    //       setCopyTitle(`Copied!`);

    //       setTimeout(() => {
    //         setCopyTitle('Copy');
    //       }, 2000);
    //     };

    //     return (
    //       <div
    //         onMouseEnter={() => setHoveredRow(params.id)}
    //         onMouseLeave={() => setHoveredRow(null)}
    //         style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', color: '#1e90ff' }}
    //       >
    //         <Link underline="hover" style={{ marginRight: 8, color: '#1e90ff' }}>
    //           {params.row.id}
    //         </Link>
    //         {hoveredRow === params.id && (
    //           <Tooltip title={copyTitle}>
    //             <IconButton onClick={handleCopy} size="small">
    //               <ContentCopyRoundedIcon fontSize="smallest" />
    //             </IconButton>
    //           </Tooltip>
    //         )}
    //       </div>
    //     );
    //   }
    // },
    { field: 'UnitId', headerName: 'Unit ID', width: 150 },
    { field: 'Name', headerName: 'Name', flex: 1 },
    { field: 'Description', headerName: 'Description', flex: 1 },
    {
      field: 'Sensor',
      headerName: 'Sensor',
      width: 150,
      renderCell: (params) => {
        const sensorWithId = params.row.Sensors?.find(
          (sensor) => sensor.Sensor?.SensorId,
        );

        return <label>{sensorWithId?.Sensor?.SensorId}</label>;
      },
    },
    {
      field: 'Tags',
      headerName: 'Tags',
      flex: 1,
      renderCell: (params) => {
        const tags = params.row.Tags;

        if (tags && tags.length > 0) {
          return (
            <div>
              {tags?.map((tag, index) => (
                <Chip
                  key={tag.TagId}
                  label={tag.Text}
                  size="small"
                  sx={{ borderRadius: 1, marginLeft: 0.5, marginBottom: 0.5 }}
                />
              ))}
            </div>
          );
        }

        return <span></span>;
      },
    },
    {
      field: 'AlarmGroups',
      headerName: 'Alarm Groups',
      flex: 1,
      renderCell: (params) => {
        const alarmGroups = params.row.AlarmGroups;

        if (alarmGroups && alarmGroups.length > 0) {
          return (
            <div>
              {alarmGroups.map((group, index) => (
                <Chip
                  size="small"
                  icon={<NotificationsIcon />}
                  key={index}
                  label={group.Name}
                />
              ))}
            </div>
          );
        }

        return <span>No Alarm Groups</span>;
      },
    },
  ];

  return (
    <>
      <StyledDataGrid
        rows={rows}
        columns={columns}
        rowModesModel={rowModesModel}
        onRowModesModelChange={handleRowModesModelChange}
        onRowEditStop={handleRowEditStop}
        processRowUpdate={processRowUpdate}
        onRowClick={handleRowClick}
        getRowClassName={getRowClassName}
        noRowsOverlay={DataGridNoRowsCustomOverlay}
        toolbar={UnitDataGridToolbar}
        isLoading={isLoading}
        rowsName="Units"
        height="90vh"
      />
      <UnitDetailDrawer
        unit={selectedRow}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
    </>
  );
};

export default UnitDataGrid;
